'use client';

import { useTranslations } from '@/lib/i18n-utils';
import { daDK } from '@clerk/localizations';

export function useClerkLocalization() {
  const { locale } = useTranslations();
  return locale === 'da' ? daDK : undefined;
}
